<template>
  <v-menu offset-y>
    <v-btn flat slot="activator" color="primary" dark>
      <v-avatar size="35">
        <img :src="locale.image">
      </v-avatar>
    </v-btn>
    <v-list>
      <v-list-tile v-for="lang in languages" :key="lang.key" @click="locale = lang">
        <v-list-tile-content>
          <v-list-tile-title v-html="lang.name"></v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-avatar size="35">
          <img :src="lang.image">
        </v-list-tile-avatar>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import Cookie from 'js-cookie'
import config from '@/config'

export default {
  created() {
    const cookieLang = JSON.parse(Cookie.get('lang') || null)
    if(cookieLang) {
      const locale = config.locales.find(lang => lang.key == cookieLang.key)
      this.$store.dispatch('setLocale', locale)
    } else {
      this.$store.dispatch('setLocale', config.locales[0])
    }
  },

  computed: {
    languages() {
      return config.locales
    },

    locale: {
      get() { return this.$store.getters.locale },
      set(value) { this.$store.dispatch('setLocale', value) }
    }
  },

  watch: {
    locale(locale) {
      Cookie.set('lang', JSON.stringify(locale))
    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectLanguage.vue?1a911fde